<template>
  <div>
    <!-- Envio proposta -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          v-if="(proposta.geradoProposta || proposta.tipoProposta === 'semchecklist') && proposta.statusProposta !== 'aguardandoassinatura'"
          v-b-tooltip.hover.lefttop
          :title="proposta.etiquetas.some(som => som.descricao === 'Aguardando envio de dados' && som.etiquetaSistema) ? 'Reenviar notificação' : 'Enviar proposta'"
          size="md"
          :variant="desabilitarEnvio ? 'outline-secondary' : 'outline-primary'"
          :disabled="desabilitarEnvio"
          @click="enviarProposta"
        >
          <font-awesome-icon :icon="faPaperPlane" />
        </b-btn>
        <b-btn
          v-else-if="proposta.statusProposta !== 'aguardandoassinatura'"
          v-b-tooltip.hover.lefttop
          title="Enviar checklist"
          size="md"
          :variant="desabilitaEnviarChecklist? 'outline-secondary' : 'outline-primary'"
          :disabled="desabilitaEnviarChecklist"
          @click="salvarPropostaChecklist(false, true)"
        >
          <font-awesome-icon :icon="faPaperPlane" />
        </b-btn>
        <b-btn
          v-else-if="proposta.statusProposta === 'aguardandoassinatura'"
          v-b-tooltip.hover.lefttop
          title="Reenviar notificação do contrato"
          size="md"
          variant="outline-primary"
          @click="enviarNotificacaoAssinatura"
        >
          <font-awesome-icon :icon="faPaperPlane" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Imprimir proposta -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-dropdown
          v-b-tooltip.hover.lefttop
          title="Imprimir"
          size="md"
          :variant="desabilitarImpressora ? 'outline-secondary' : 'outline-primary'"
          no-caret
          :disabled="desabilitarImpressora"
        >
          <template #button-content>
            <font-awesome-icon
              :style="desabilitarImpressora ? 'outline-secondary' : 'outline-primary'"
              :icon="faPrint"
            />
          </template>
          <b-dropdown-item-btn
            v-if="proposta.tipoProposta !== 'semchecklist'"
            @click="abrirChecklist"
          >
            Imprimir checklist
          </b-dropdown-item-btn>
          <b-dropdown-item-btn
            v-if="getStatusProposta !== 6"
            @click="abrirProposta"
          >
            Imprimir proposta
          </b-dropdown-item-btn>
          <b-dropdown-item-btn
            v-if="proposta.geraContrato && (proposta.statusProposta === 'aguardandoassinatura' || proposta.statusProposta === 'finalizada')"
            @click="abrirContrato"
          >
            Imprimir contrato
          </b-dropdown-item-btn>
        </b-dropdown>
      </b-col>
    </b-row>

    <!-- Etiqueta -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          id="etiqueta"
          v-b-tooltip.hover.lefttop
          title="Etiquetas"
          size="md"
          :variant="'outline-primary'"
        >
          <font-awesome-icon :icon="faTag" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Alterar Status -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Alterar Status manual"
          size="md"
          :variant="desabilitarAlterarStatus ? 'outline-secondary' : 'outline-primary'"
          :disabled="desabilitarAlterarStatus"
          @click="abritAlterarStatusProposta()"
        >
          <font-awesome-icon
            :style="desabilitarAlterarStatus ? 'outline-secondary' : 'outline-primary'"
            :icon="faEdit"
          />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Dados financeiro -->
    <b-row
      v-if="mostrarDadosFinanceiro"
      class="mb-50"
    >
      <b-col cols="auto">
        <b-btn
          id="dadosFinanceiro"
          v-b-tooltip.hover.lefttop
          title="Dados para o financeiro"
          size="md"
          :variant="'outline-primary'"
          @click="abrirDadosContratante"
        >
          <font-awesome-icon :icon="['fas', 'circle-dollar-to-slot']" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Pré Contrato -->
    <b-row :class="{'mb-50': mostrarPreGeracao}">
      <b-col
        v-if="mostrarPreGeracao"
        cols="auto"
      >
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Pré - geração do contrato comercial"
          size="md"
          :variant="desabilitarPreGeracao ? 'outline-secondary' : 'outline-primary'"
          :disabled="desabilitarPreGeracao"
          @click="abrirPreContrato"
        >
          <font-awesome-icon :icon="faFileSignature" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Envia contrato manualmente -->
    <b-row :class="{'mb-50': mostrarPreGeracao}">
      <b-col
        v-if="mostrarPreGeracao"
        cols="auto"
      >
        <b-btn
          v-if="abilitarAprovarContratoManualmente"
          v-b-tooltip.hover.lefttop
          title="Aprovar contrato manualmente"
          size="md"
          :variant="'outline-danger'"
          :disabled="!abilitarAprovarContratoManualmente"
          @click="abrirAprovarContratoManualmente"
        >
          <font-awesome-icon :icon="faFileSignature" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Integrações proposta -->
    <b-row
      v-if="mostrarBotaoIntegracoes"
      class="mb-50"
    >
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Integrações"
          variant="outline-primary"
          @click="$refs.integracoesModal.show()"
        >
          <font-awesome-icon :icon="faRobot" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Histórico -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Histórico"
          size="md"
          :variant="!proposta.id ? 'outline-secondary' : 'outline-primary'"
          :disabled="!proposta.id"
          @click="mostrarHistorico = true"
        >
          <font-awesome-icon :icon="faHistory" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Visualizacoes -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Visualizações"
          size="md"
          :variant="!proposta.id ? 'outline-secondary' : 'outline-primary'"
          :disabled="!proposta.id"
          @click="mostrarVisualizacao = true"
        >
          <font-awesome-icon :icon="faEye" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Documentos -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Documentos"
          size="md"
          :variant="!proposta.id ? 'outline-secondary' : 'outline-primary'"
          :disabled="!habilitarPropostaDocumentosModal"
          @click="abrirDocumentosPropostaModal"
        >
          <font-awesome-icon :icon="faBookOpen" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Copia -->
    <b-row class="mb-50">
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Copiar"
          size="md"
          :variant="!proposta.id || ((proposta.tipoProposta === 'constituicao' || proposta.tipoProposta === 'transferencia') && !proposta.geradoProposta) ? 'outline-secondary' : 'outline-primary'"
          :disabled="!proposta.id || ((proposta.tipoProposta === 'constituicao' || proposta.tipoProposta === 'transferencia') && !proposta.geradoProposta)"
          @click="copiarProposta"
        >
          <feather-icon icon="CopyIcon" />
        </b-btn>
      </b-col>
    </b-row>

    <!-- Excluir proposta -->
    <b-row>
      <b-col cols="auto">
        <b-btn
          v-b-tooltip.hover.lefttop
          title="Excluir"
          size="md"
          variant="outline-danger"
          @click="excluirProposta"
        >
          <font-awesome-icon :icon="faTrash" />
        </b-btn>
      </b-col>
    </b-row>

    <!--Historicos-->
    <historico-proposta-modal
      v-if="mostrarHistorico"
      :proposta-id="proposta.id"
      :interno="true"
      @hidden="mostrarHistorico = false"
    />

    <historico-proposta-modal
      v-if="mostrarVisualizacao"
      :proposta-id="proposta.id"
      :interno="true"
      :label="'Histórico de visualização'"
      :tipo-historico="'visualizacao'"
      @hidden="mostrarVisualizacao = false"
    />

    <!-- Componentes de tela -->
    <alterar-status
      ref="alterarStatus"
      :proposta-atual="proposta"
      :tipo-acres-desc="proposta.porcentagem ? '%' : 'R$'"
      @alterar-status="alterarStatus"
    />

    <cadastro-etiqueta
      :proposta-id="proposta.id"
      @adicionar-etiqueta-selecionada="adicionarEtiquetaSelecionada"
      @remover-etiqueta="removerEtiqueta"
      @update-etiqueta="updateEtiqueta"
      @adicionar-etiqueta="adicionarEtiqueta"
    />

    <pre-geracao-contrato-proposta
      ref="preGeracaoContrato"
      :proposta-atual="proposta"
      :status-proposta="proposta.statusProposta"
      @atualiza-cartao-proposta="atualizarProposta($event)"
      @abrir-modal="abritAlterarStatusProposta()"
    />

    <aprovar-contrato-manual
      ref="aprovarContratoManual"
      :proposta="proposta"
      :proposta-id="proposta.id"
      @atualiza-cartao-proposta="atualizarProposta($event)"
      @abrir-modal="abrirAprovarContratoManualmente"
    />

    <documentos-proposta-modal
      ref="documentosPropostaModal"
      :proposta="proposta"
      :proposta-id="proposta.id"
      @atualiza-cartao-proposta="atualizarProposta($event)"
      @abrir-modal="abrirDocumentosPropostaModal"
    />

    <propostas-agrupadas
      ref="modalPropostaAgrupada"
      :proposta-id="proposta.id"
      @enviado="$emit('limpar-dados')"
    />

    <dados-contratante
      ref="dadosContrante"
      :value="proposta.propostaContratanteDetails"
      :proposta-id="proposta.id"
      :show-alteracao="proposta.propostaContratanteDetails === undefined ? false : true "
    />

    <integracoes-modal
      ref="integracoesModal"
      :empresas="proposta.empresasVinculadas"
      :proposta-id="proposta.id"
      :data-execucao="proposta.dataExecucaoOmie"
      :data-execucao-contrato="proposta.dataExecucaoContratoOmie"
      :alterado-contrato-omie-manualmente="proposta.alteradoContratoOmieManualmente"
      :contratante="proposta.propostaContratanteDetails"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPaperPlane, faPrint, faTrash, faCheckSquare, faTag, faEye, faHistory, faFileContract, faFileInvoice, faEdit, faFileSignature, faRobot, faBookOpen,
} from '@fortawesome/free-solid-svg-icons'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiPreGeracao from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'
import docuSign from '@/shared/mixins/docu-sign/docu-sign'

import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import pessoaApi from '@/app-modulo/comercial/pessoa/shared/services/api'
import apiTemplateEmail from '@/app-modulo/comuns/templates-gerais/shared/components/services/api'

export default {
  name: 'BotoesAcoes',
  components: {
    FontAwesomeIcon,
    HistoricoPropostaModal: () => import('@/app-modulo/comercial/portal-proposta/shared/components/historico-proposta/HistoricoProposta.vue'),
    AlterarStatus: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/alterar-status/AlterarStatus.vue'),
    CadastroEtiqueta: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/cadastro-etiqueta/CadastroEtiqueta.vue'),
    PreGeracaoContratoProposta: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/PreGeracaoContratoProposta.vue'),
    PropostasAgrupadas: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/propostas-agrupadas/PropostasAgrupadas.vue'),
    DadosContratante: () => import('../dados-contrantante-interno/DadosContratanteInterno.vue'),
    IntegracoesModal: () => import('./shared/components/modals/IntegracoesModal.vue'),
    AprovarContratoManual: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/aprovar-contrato-manual/AprovarContratoManual.vue'),
    DocumentosPropostaModal: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/documentos-proposta/DocumentosPropostaModal.vue'),
  },
  props: {
    proposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faPaperPlane,
      faPrint,
      faTrash,
      faCheckSquare,
      faTag,
      faEye,
      faBookOpen,
      faHistory,
      faFileContract,
      faFileInvoice,
      faEdit,
      faFileSignature,
      faRobot,
      mostrarHistorico: false,
      mostrarVisualizacao: false,
      propostaCopiaAcoes: null,
      url: null,
      arquivoDeletar: null,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getStatusProposta']),
    desabilitarEnvio() {
      return !this.proposta.id || ((this.getStatusProposta === 3 && !this.proposta.etiquetas.some(som => som.descricao === 'Aguardando envio de dados' && som.etiquetaSistema)) || this.getStatusProposta === 8
        || this.getStatusProposta === 4 || this.getStatusProposta === 5)
    },
    desabilitaEnviarChecklist() {
      return this.getStatusProposta === 4 || this.proposta.responsavelAResponder !== 'pessoaresponsavel' || this.proposta.etiquetas.find(find => find.descricao === 'Checklist respondido')
    },
    desabilitarAlterarStatus() {
      return this.getStatusProposta === 4 || this.getStatusProposta === 5
    },
    desabilitarImpressora() {
      return !this.proposta.id
    },
    desabilitarPreGeracao() {
      return ((this.getStatusProposta !== 3 && this.getStatusProposta !== 9 && this.getStatusProposta !== 8) || !this.proposta.geraContrato)
    },
    abilitarAprovarContratoManualmente() {
      return ((this.getStatusProposta === 9 || this.getStatusProposta === 3 || this.getStatusProposta === 7) || !this.proposta.geraContrato)
    },
    mostrarPreGeracao() {
      return this.proposta.tipoProposta !== 'semchecklist' && this.proposta.geraContrato
    },
    mostrarDadosFinanceiro() {
      return this.proposta.tipoProposta === 'semchecklist' && (this.proposta.propostaContratanteDetails && (this.proposta.propostaContratanteDetails.inscricao && this.proposta.propostaContratanteDetails.inscrica !== ''))
    },
    mostrarBotaoIntegracoes() {
      return (this.getStatusProposta === 2 || this.getStatusProposta === 3 || this.getStatusProposta === 8 || this.getStatusProposta === 9 || this.getStatusProposta === 4)
      // && ((this.proposta.tipoProposta === 'semchecklist' && this.proposta.semContratante && this.proposta.propostaContratanteDetails
      //   && this.proposta.propostaContratanteDetails.statusOmie !== 0)
      //   || (this.proposta.empresasVinculadas && this.proposta.empresasVinculadas.length > 0
      //     && !this.proposta.empresasVinculadas.some(som => som.empresaResumida.statusOmie === 0)
      //     && ((this.proposta.tipoProposta === 'semchecklist' && this.proposta.existeCadastroOmie)
      //       || (this.proposta.tipoProposta !== 'semchecklist' && this.proposta.geraContrato)))
      //       || (this.proposta.tipoProposta === 'semchecklist' && this.proposta.osConstituicao))
    },
  },
  methods: {
    ...mapActions('listas', [
      'adicionarPendente',
      'removerProposta',
      'mudarColunaCartaoEnvio',
      'mudarColunaStatus',
      'atualizarPropostaColuna',
      'removerEtiquetasPropostas']),
    enviarProposta() {
      this.propostaCopiaAcoes = JSON.parse(JSON.stringify(this.proposta))
      this.validarServicosEPacotes(this.proposta)
      this.removeCaracteresPorcentagem(this.propostaCopiaAcoes)
      if ((!this.proposta.empresasPessoa || this.proposta.empresasPessoa.length === 0) && this.proposta.tipoProposta === 'semchecklist' && !this.proposta.semContratante && !this.proposta.osConstituicao) {
        this.$erro('Informe os contratante(s)!')
        this.$emit('campo-obrigatorio')
      } else if (!this.proposta.etiquetas.some(som => som.descricao === 'Aguardando envio de dados' && som.etiquetaSistema)) {
        this.envioPropostas()
      } else {
        this.$isLoading(true)
        const propostaCopia = JSON.parse(JSON.stringify(this.proposta))
        propostaCopia.empresasPessoa = null
        api.notificarPropostaAguardandoEnvioDados(propostaCopia)
          .then(() => {
            this.$emit('limpar-dados')
            this.$sucesso('Notificacao enviada!')
          })
          .catch(err => {
            this.$erro(err.response.data.message || err.message)
            throw err
          })
          .finally(() => {
            this.$isLoading(false)
          })
      }
    },
    envioPropostas() {
      pessoaApi.existeMaisDeUmaProposta(this.proposta.pessoa.id, this.proposta.statusProposta)
        .then(response => {
          if ((this.proposta.statusProposta === 'pendenteenvio' || this.proposta.statusProposta === 'negociacao' || this.proposta.statusProposta === 'naoaprovada') && response.data) {
            this.$refs.modalPropostaAgrupada.$refs.modalAgrupada.show()
          } else {
            this.$isLoading(true)
            apiTemplateEmail.validaTemplates([this.proposta.id])
              .then(res => {
                if (res.data !== '') {
                  this.$atencaoHtml('', `<strong>${res.data} <br> as propostas não serão enviadas</strong>`, 'Ciente')
                    .then(() => { })
                } else {
                  this.$isLoading(true)
                  api.enviarProposta(this.propostaCopiaAcoes, 'envioProposta')
                    .then(payload => {
                      this.$emit('limpar-dados')
                      this.$sucesso('Proposta enviada!')
                      if (this.proposta.statusProposta === 'pendenteenvio') {
                        this.mudarColunaCartaoEnvio(payload.data)
                      } else {
                        this.atualizarPropostaColuna({ colunaDe: 2, propostaCartao: payload.data })
                      }
                    })
                    .catch(err => {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
                          icon: 'AlertCircleIcon',
                          variant: 'danger',
                        },
                      })
                      throw err
                    })
                    .finally(() => {
                      this.$isLoading(false)
                    })
                }
              })
              .catch(err => {
                this.$erro('erro ao buscar informações')
                throw err
              })
              .finally(() => {
                this.$isLoading(false)
              })
          }
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },

    validarServicosEPacotes(proposta) {
      if (!proposta.propostasPacotes.some(s => s.servicos) && !proposta.servicos.some(s => s.servico) && !proposta.servicosAdicionais.some(s => s.servico)) {
        this.$erro('Não é possivel enviar proposta sem pacote, serviços ou bonificação')
        throw new ''()
      }
      if (proposta.propostasPacotes) {
        proposta.propostasPacotes.forEach(pacote => {
          if (pacote.servicos) {
            pacote.servicos.forEach((servico, index) => {
              const valorUnitarioServico = index === 0 ? servico.valorAuditar + pacote.acrescimoPacote - pacote.descontoPacote : servico.valorAuditar
              if (valorUnitarioServico <= 0) {
                this.$erro('O subtotal do serviço não pode ser menor ou igual a R$ 0,00')
                throw new ''()
              }
            })
          }

          const valorTotal = pacote.valorPacote + pacote.acrescimoPacote - pacote.descontoPacote
          if (valorTotal <= 0) {
            this.$erro('O subtotal do pacote não pode ser menor ou igual a R$ 0,00')
            throw new ''()
          }
        })
      }
      if (proposta.servicos && proposta.servicos.length > 0 && proposta.servicos.some(s => s.servico) && this.calculoTotalServicoOuPacote(proposta.servicos)) {
        this.$erro('O subtotal do serviço não pode ser menor ou igual a R$ 0,00')
        throw new ''()
      }
      if (proposta.servicosAdicionais && proposta.servicosAdicionais.some(s => s.servico) && this.calculoTotalServicoOuPacote(proposta.servicosAdicionais)) {
        this.$erro('O subtotal da bonificação não pode ser menor ou igual a R$ 0,00')
        throw new ''()
      }
    },
    calculoTotalServicoOuPacote(servicos) {
      return servicos.some(s => (s.servico.valorAuditar + s.acrescimo - s.desconto) <= 0)
    },
    salvarPropostaChecklist(gerarProposta, enviarProposta) {
      this.$emit('enviar-checklist', { gerarProposta, enviarProposta })
    },
    copiarProposta() {
      if (this.proposta.checklistCNPJ && this.proposta.checklistCNPJ.length > 0) {
        this.proposta.itemChecklistPropostas.push(...this.proposta.checklistCNPJ)
      }
      this.propostaCopiaAcoes = { ...this.proposta }
      if (this.proposta.tipoProposta === 'transferencia' || this.proposta.tipoProposta === 'constituicao') {
        this.proposta.itemChecklistPropostas = this.proposta.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
      }
      this.removeCaracteresPorcentagem(this.propostaCopiaAcoes)
      this.converterEmpresasPessoa(this.propostaCopiaAcoes)
      api.copiarProposta(this.propostaCopiaAcoes)
        .then(payload => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Proposta copiada!',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          const propostaNova = payload.data
          this.adicionarPendente(propostaNova)
          this.$emit('limpar-dados')
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          throw err
        })
    },
    excluirProposta() {
      if (this.proposta.id) {
        this.$swal({
          text: 'Deseja realmente excluir essa proposta?',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          showCancelButton: true,
          focusConfirm: false,
          icon: 'question',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1',
          },
        })
          .then(result => {
            if (result.value) {
              api.excluirProposta(this.proposta.id)
                .then(() => {
                  const payload = { propostaId: this.proposta.id, statusProposta: this.proposta.statusProposta }
                  this.removerProposta(payload)
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Proposta removida com sucesso',
                      icon: 'CheckCircleIcon',
                      variant: 'success',
                    },
                  })
                  this.$emit('limpar-dados')
                })
                .catch(err => {
                  if (err.response && err.response.status === 403) {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Você não possui permissão para remover a proposta comercial!',
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: err.response.data.message || err.message,
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                      },
                    })
                  }
                  throw err
                })
            }
          })
      }
    },
    alterarStatus(cartaoProposta) {
      const payload = { propostaCartao: cartaoProposta, colunaDe: this.proposta.statusProposta, colunaPara: cartaoProposta.statusProposta }
      this.mudarColunaStatus(payload)
      if (this.proposta.statusProposta === cartaoProposta.statusProposta) {
        this.atualizarPropostaColuna({ colunaDe: 2, propostaCartao: cartaoProposta })
      }
      this.$emit('atualizar-dados')
    },

    abritAlterarStatusProposta() {
      this.$refs.alterarStatus.$refs.modalAlterarStatus.show()
    },
    adicionarEtiquetaSelecionada(etiqueta) {
      this.proposta.etiquetas.push(etiqueta)
    },
    removerEtiqueta(etiqueta) {
      const index = this.proposta.etiquetas.findIndex(find => find.id === etiqueta.id)
      if (index >= 0) {
        this.proposta.etiquetas.splice(index, 1)
      }
      this.removerEtiquetasPropostas(etiqueta)
    },
    updateEtiqueta(etiqueta) {
      const index = this.proposta.etiquetas.findIndex(find => find.id === etiqueta.id)
      this.proposta.etiquetas.splice(index, 1)
      this.proposta.etiquetas.splice(index, 0, etiqueta)
    },
    adicionarEtiqueta(etiqueta) {
      this.proposta.etiquetas.push(etiqueta)
    },
    abrirProposta() {
      if (this.proposta.id && this.proposta.id > 0) {
        const routeData = this.$router.resolve({ name: 'relatorioproposta', params: { id: this.proposta.id, externa: false } })
        window.open(routeData.href, '_blank')
      }
    },
    abrirPreContrato() {
      this.$refs.preGeracaoContrato.$refs.preGeracao.show()
    },
    abrirAprovarContratoManualmente() {
      this.$refs.aprovarContratoManual.$refs.aprovarContratoManualModal.show()
    },
    abrirChecklist() {
      if (this.proposta.id && this.proposta.id > 0) {
        const routeData = this.$router.resolve({ name: 'relatoriochecklist', params: { id: this.proposta.id } })
        window.open(routeData.href, '_blank')
      }
    },
    removeCaracteresPorcentagem(proposta) {
      if (this.proposta.porcentagem) {
        for (let i = 0; i < proposta.propostasPacotes.length; i += 1) {
          const element = proposta.propostasPacotes[i]
          if (element.acrescimoPacote) {
            this.propostaCopiaAcoes.propostasPacotes[i].acrescimoPacote = parseFloat(element.acrescimoPacote.replace('%', ''), 10)
          }
          if (element.descontoPacote) {
            this.propostaCopiaAcoes.propostasPacotes[i].descontoPacote = parseFloat(element.descontoPacote.replace('%', ''), 10)
          }
        }
      }

      if (proposta.servicos && proposta.servicos.length > 0 && this.proposta.porcentagem && proposta.servicos.some(som => som.servico)) {
        for (let index = 0; index < proposta.servicos.length; index += 1) {
          // eslint-disable-next-line prefer-destructuring
          const acrescimo = proposta.servicos[index].acrescimo
          // eslint-disable-next-line prefer-destructuring
          const desconto = proposta.servicos[index].desconto
          if (acrescimo) {
            this.propostaCopiaAcoes.servicos[index].acrescimo = parseFloat(acrescimo.replace('%', ''), 10)
          }
          if (desconto) {
            this.propostaCopiaAcoes.servicos[index].desconto = parseFloat(desconto.replace('%', ''), 10)
          }
        }
      }

      if (proposta.servicosAdicionais && proposta.servicosAdicionais.length > 0 && this.proposta.porcentagem && proposta.servicosAdicionais.some(som => som.servico)) {
        for (let index = 0; index < proposta.servicosAdicionais.length; index += 1) {
          // eslint-disable-next-line prefer-destructuring
          const acrescimo = proposta.servicosAdicionais[index].acrescimo
          // eslint-disable-next-line prefer-destructuring
          const desconto = proposta.servicosAdicionais[index].desconto

          if (acrescimo) {
            this.propostaCopiaAcoes.servicosAdicionais[index].acrescimo = parseFloat(acrescimo.replace('%', ''), 10)
          }
          if (desconto) {
            this.propostaCopiaAcoes.servicosAdicionais[index].desconto = parseFloat(desconto.replace('%', ''), 10)
          }
        }
      }
    },
    converterEmpresasPessoa(proposta) {
      if (proposta.tipoProposta !== 'semchecklist' && proposta.empresasPessoa) {
        const array = []
        proposta.empresasPessoa.forEach(each => {
          if (typeof each === 'string') {
            array.push(JSON.parse(each))
          } else {
            array.push(each)
          }
        })
        this.propostaCopiaAcoes.empresasPessoa = array
      }
    },
    enviarNotificacaoAssinatura() {
      if (this.getStatusProposta === 9) {
        this.$isLoading(true)
        docuSign.enviarContratoAtualizado(this.proposta.id)
          .then(() => {
            this.$sucesso('Contrato enviado!')
          })
          .catch(err => {
            this.$erro(err)
            throw err
          })
          .finally(() => {
            this.$isLoading(false)
          })
      } else {
        apiPreGeracao.enviarNotificaoContrato(this.proposta.id)
          .then(() => {
            this.$sucesso('Contrato enviado!')
          })
          .catch(err => {
            this.$erroResponse(err)
            throw err
          })
      }
    },
    atualizarProposta(value) {
      this.atualizarPropostaColuna(value)
      this.$emit('limpar-dados')
    },
    abrirContrato() {
      docuSign.getArquivoContrato(this.proposta.id)
        .then(payload => {
          // eslint-disable-next-line prefer-destructuring
          const url = payload.data.url
          this.arquivoDeletar = payload.data.fileName
          window.open(url, '_blank')
          setTimeout(() => {
            docuSign.deletarArquivo(this.arquivoDeletar)
          }, 3000)
        })
    },
    abrirDadosContratante() {
      this.$refs.dadosContrante.show()
    },
    habilitarPropostaDocumentosModal() {
      return this.proposta.id && this.proposta.id > 0
    },
    abrirDocumentosPropostaModal() {
      this.$refs.documentosPropostaModal.show()
    },
  },
}
</script>
